import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB6CaxR8g8QgTnhv_vC5BUyvVKGwehn9Yc",
  authDomain: "all-black-screen.firebaseapp.com",
  projectId: "all-black-screen",
  storageBucket: "all-black-screen.firebasestorage.app",
  messagingSenderId: "379962779632",
  appId: "1:379962779632:web:ba40c195469f5fb2725f35",
  measurementId: "G-7L8ZFK6DHJ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
